import React from 'react';

const ContactPage = () => {
  return (
    <div className="bg-white">
      <section className="bg-white">
        <div className="mx-3 md:mx-10 lg:mx-16 py-16 md:py-20">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-inter font-medium text-acBlack leading-[1.05]">
              Contact Us
            </h1>

            <p className="mt-6 text-sm md:text-base text-gray-700 font-inter leading-relaxed">
              We’re here to help with questions about Valicourses, course listings, and general enquiries. Please note that
              we do not provide technical support for courses hosted on third-party platforms.
            </p>

            <div className="mt-10 rounded-2xl bg-gray-50 border border-gray-100 px-6 md:px-8 py-6">
              <h2 className="text-xl md:text-2xl font-inter font-semibold text-acBlack">General Enquiries</h2>

              <p className="mt-3 text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                For general questions about Valicourses, partnerships, or the website:
              </p>

              <div className="mt-6 space-y-3 text-sm md:text-base font-inter">
                <div className="text-gray-700">
                  <span className="font-semibold text-acBlack">Email:</span>{' '}
                  <a
                    href="mailto:hello@valicourses.com"
                    className="text-acBlack hover:text-gray-700 transition-colors"
                  >
                    hello@valicourses.com
                  </a>
                </div>

                <div className="text-gray-700">
                  <span className="font-semibold text-acBlack">Privacy enquiries:</span>{' '}
                  <a
                    href="mailto:privacy@valicourses.com"
                    className="text-acBlack hover:text-gray-700 transition-colors"
                  >
                    privacy@valicourses.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
